import { render, staticRenderFns } from "./NominatePrimary.vue?vue&type=template&id=489ca700&"
import script from "./NominatePrimary.vue?vue&type=script&lang=js&"
export * from "./NominatePrimary.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports